<template>
  <div class="col-xs-12 col-md-6">
    <form-group-search-select
      v-if="professores"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="professores"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import MatriculaService from "../../../../domain/corpore/MatriculaService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-disciplina-ativa",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    cursoId: null,
    login: {
      type: String,
      default: ""
    }
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    professores() {
      const matriculaService = new MatriculaService(this.$http);
      let login = this.login != "" ? this.login : this.usuario.login;
      return matriculaService
        .getDisciplinasMatricula(login)
        .then(result => {
          return result.map(periodo => ({
            value: periodo.CODDISC,
            text: periodo.DISCIPLINA
          }));
        })
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DisciplinaAtiva.vue